import { useAffiliateReferralsQuery } from '../queries/useAffiliateReferralsQuery'

export const useAffiliateReferrals = ({ page, limit }: { page: number; limit: number }) => {
  const { affiliateReferralsQuery } = useAffiliateReferralsQuery([
    {
      page: page - 1,
      size: limit,
    },
  ])

  return {
    affiliateReferrals: {
      referrals: affiliateReferralsQuery.data?.results || [],
      pageResult: affiliateReferralsQuery.data?.pageResult,
      isLoading: affiliateReferralsQuery.isLoading,
    },
  }
}
